<template src="./template.html" ></template>

<script>
import MyAlert from '../../components/alert/MyAlert.vue'
import MyListButtons from '../add/Buttons.vue'
export default {
  name: 'cost-items',
  props: ['formTitle'],
  data() {
    return {
      valid: false,
      alert: false,
      model: {},
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    if (this.formState === 'edit') {
      let _mid = this.$router.currentRoute.path.split("/")[3]
      let data = {
        url: `/api/${this.route}`,
        params: {
          mid: _mid
        },
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
    }
  },
  methods: {
    async onSave() {
      // console.log(model);
      let _method = 'POST'
      if (this.formState === 'edit') {
        _method = 'PUT'
      }
      this.$refs.form.validate()
      let _data = {
        method: _method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        },
      }
      // console.log(_data);
      if (this.valid) {
        await this.$store.dispatch('save', _data)
        let res = this.$store.getters.saveData
        // console.log(this.alertData);
        if (res && (res.insert || res.update)) {
          this.alert = true
        }
      }
    },
  },
  // mounted() {
  //   this.$refs.title.focus()
  // },
  components: {
    MyAlert,
    MyListButtons
  },
}
</script>

<style lang="scss" scoped>
</style>
